
import * as React from 'react';
import { INameDialogProps, NameDialog } from '../../nameDialog/NameDialog';
import { WarningDialog } from '../../warningDialog/WarningDialog';
import { KeyboardZone } from '../../keyboard/KeyboardZone';

export interface IRenameDialogProps extends INameDialogProps {
  lockedWarningMessage?: string | undefined;
  warningDialogCancelText?: string | undefined;
}

export const RenameDialog: React.StatelessComponent<IRenameDialogProps> = (props: IRenameDialogProps) => {
  const {
    lockedWarningMessage,
    warningDialogCancelText,
    onCancel,
    title
  } = props;

  return (
    lockedWarningMessage ?
      (
        <WarningDialog
          cancelText={ warningDialogCancelText }
          title={ title }
          prompt={ lockedWarningMessage }
          onCancel={ onCancel }
        />
      ) :
      (
        <KeyboardZone>
          <NameDialog { ...props } />
        </KeyboardZone>
      )
  );
};
